var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useState, useEffect, Fragment } from 'react';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import messages from './messages';
import getByPath from 'lodash/get';
import { injectIntl } from 'react-intl';
import { getValues, convertTimeValues } from './helpers';

var Timespan = function Timespan(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ['title']);

  var Component = getTimespanComponent(rest);

  var get = function get(intl) {
    return function (id) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return messages.get(id, _extends({ intl: intl }, values || {}));
    };
  };
  var getValue = function getValue(valueType, currency, intl) {
    return function (value) {
      if (valueType !== 'currency') {
        if (value === 99999 && valueType === 'days') return get(intl)('label.responsible-gaming.unlimited');

        var values = convertTimeValues(value, valueType);
        return Object.entries(values).filter(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              valueType = _ref3[0],
              value = _ref3[1];

          return value > 0;
        }).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              valueType = _ref5[0],
              value = _ref5[1];

          return messages.getValue(value, valueType, null, intl);
        }).slice(0, 2).join(' ');
      } else {
        return messages.getValue(value, valueType, currency, intl);
      }
    };
  };

  return React.createElement(
    'div',
    { className: 'ResponsibleGamingWidget__timespan' },
    title && React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-title' },
      title
    ),
    React.createElement(Component, _extends({}, rest, {
      isTime: ['hours', 'minutes', 'days'].includes(rest.valueType),
      messages: {
        get: get(rest.intl),
        getValue: getValue(rest.valueType, rest.currency, rest.intl)
      }
    }))
  );
};

export default injectIntl(Timespan);

/**
 * Map normalized limits to a timespan component.
 */
var getTimespanComponent = function getTimespanComponent(_ref6) {
  var confirmLimit = _ref6.confirmLimit,
      pendingActivateLimit = _ref6.pendingActivateLimit,
      pendingDeleteLimit = _ref6.pendingDeleteLimit,
      pickLimits = _ref6.pickLimits;

  if (confirmLimit) return ConfirmTimespan;
  if (pendingActivateLimit || pendingDeleteLimit) return PendingTimespan;
  if (Array.isArray(pickLimits) && pickLimits.length > 1) return PickTimespan;
  return DefaultTimespan;
};

var PickTimespan = function PickTimespan(_ref7) {
  var pickLimits = _ref7.pickLimits,
      onPickLimit = _ref7.onPickLimit,
      messages = _ref7.messages;
  return React.createElement(
    Fragment,
    null,
    messages.get('label.responsible-gaming.pick-limit'),
    pickLimits.map(function (l, k) {
      return React.createElement(
        'div',
        { className: 'ResponsibleGamingWidget__timespan-row', key: k },
        messages.getValue(getByPath(l, 'Amount')),
        React.createElement(
          Button,
          {
            type: 'button',
            className: 'button tertiary tiny',
            onClick: function onClick() {
              return onPickLimit(l.Id);
            } },
          messages.get('action.responsible-gaming.pick')
        )
      );
    })
  );
};

var ConfirmTimespan = function ConfirmTimespan(_ref8) {
  var confirmLimit = _ref8.confirmLimit,
      currentLimit = _ref8.currentLimit,
      pendingActivateLimit = _ref8.pendingActivateLimit,
      pendingDeleteLimit = _ref8.pendingDeleteLimit,
      onConfirmLimit = _ref8.onConfirmLimit,
      onDeclineLimit = _ref8.onDeclineLimit,
      hideRemainingLimit = _ref8.hideRemainingLimit,
      isTime = _ref8.isTime,
      messages = _ref8.messages;
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      messages.get('message.responsiblegaming.current-limit'),
      messages.getValue(getByPath(currentLimit, 'Amount'))
    ),
    !hideRemainingLimit && React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      isTime ? messages.get('message.responsiblegaming.remaining-time') : messages.get('message.responsiblegaming.remaining-limit'),
      messages.getValue(getByPath(currentLimit, 'RemainingAmount'))
    ),
    React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-box' },
      pendingActivateLimit && messages.get('label.responsible-gaming.confirm-increase', {
        PendingActivateLimitAmount: messages.getValue(getByPath(pendingActivateLimit, 'Amount'))
      }),
      pendingDeleteLimit && messages.get('label.responsible-gaming.confirm-delete'),
      React.createElement(
        'div',
        { className: 'ResponsibleGamingWidget__timespan-box-actions' },
        React.createElement(
          Button,
          {
            type: 'button',
            className: 'button tertiary',
            onClick: function onClick() {
              return onDeclineLimit(confirmLimit.Id);
            } },
          messages.get('action.responsible-gaming.reset-limit')
        ),
        React.createElement(
          Button,
          {
            type: 'button',
            className: 'button primary',
            onClick: function onClick() {
              return onConfirmLimit(confirmLimit.Id);
            } },
          messages.get('action.responsible-gaming.accept')
        )
      )
    )
  );
};

var PendingTimespan = function PendingTimespan(_ref9) {
  var currentLimit = _ref9.currentLimit,
      pendingActivateLimit = _ref9.pendingActivateLimit,
      pendingDeleteLimit = _ref9.pendingDeleteLimit,
      onResetLimit = _ref9.onResetLimit,
      hideRemainingLimit = _ref9.hideRemainingLimit,
      messages = _ref9.messages,
      isTime = _ref9.isTime;

  var isPendingDelete = Boolean(pendingDeleteLimit && !pendingActivateLimit);
  var isPendingActivate = Boolean(pendingActivateLimit && pendingActivateLimit.Activates);
  var isPendingReview = Boolean(pendingActivateLimit && !pendingActivateLimit.Activates);
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      messages.get('message.responsiblegaming.current-limit'),
      messages.getValue(getByPath(currentLimit, 'Amount'))
    ),
    !hideRemainingLimit && React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      isTime ? messages.get('message.responsiblegaming.remaining-time') : messages.get('message.responsiblegaming.remaining-limit'),
      messages.getValue(getByPath(currentLimit, 'RemainingAmount'))
    ),
    React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-box' },
      isPendingDelete && messages.get('label.responsible-gaming.pending-delete', {
        PendingDeleteLimitExpires: pendingDeleteLimit.Expires
      }),
      isPendingActivate && messages.get('label.responsible-gaming.pending-activate', {
        PendingActivateLimitAmount: messages.getValue(pendingActivateLimit.Amount),
        PendingActivateLimitActivates: pendingActivateLimit.Activates
      }),
      isPendingReview && messages.get('label.responsible-gaming.pending-review', {
        PendingReviewLimitAmount: messages.getValue(pendingActivateLimit.Amount)
      }),
      React.createElement(
        'div',
        { className: 'ResponsibleGamingWidget__timespan-box-actions' },
        React.createElement(
          Button,
          {
            type: 'button',
            className: 'button tertiary wide',
            onClick: onResetLimit },
          messages.get('action.responsible-gaming.reset-limit')
        )
      )
    )
  );
};

var DefaultTimespan = function DefaultTimespan(_ref10) {
  var currentLimit = _ref10.currentLimit,
      newLimit = _ref10.newLimit,
      onChangeLimit = _ref10.onChangeLimit,
      validationState = _ref10.validationState,
      currency = _ref10.currency,
      timespan = _ref10.timespan,
      hideRemainingLimit = _ref10.hideRemainingLimit,
      showCurrentValue = _ref10.showCurrentValue,
      hideOther = _ref10.hideOther,
      values = _ref10.values,
      messages = _ref10.messages,
      isTime = _ref10.isTime,
      valueType = _ref10.valueType;

  var _useState = useState(newLimit ? newLimit.Amount : currentLimit ? currentLimit.Amount : 0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    if (newLimit) {
      setValue(newLimit.Amount);
    }
  }, [newLimit]);

  var _useState3 = useState('select'),
      _useState4 = _slicedToArray(_useState3, 2),
      inputMode = _useState4[0],
      setInputMode = _useState4[1];

  var options = [getByPath(currentLimit, 'Amount'), getByPath(newLimit, 'Amount')].concat(_toConsumableArray(getValues(values, currency, timespan))).filter(function (v) {
    return v;
  });
  options.sort(function (a, b) {
    return a - b;
  });
  options = [].concat(_toConsumableArray(new Set(options))).map(function (v) {
    return {
      value: v,
      label: value !== v && v === getByPath(currentLimit, 'Amount') ? messages.get('label.responsible-gaming.option.current-limit', {
        currentLimit: messages.getValue(v)
      }) : messages.getValue(v)
    };
  });
  // If not allowed to increase limit -> remove options greater than current limit
  if (validationState['limit-increase-blocked']) {
    options = options.filter(function (o) {
      return o.value <= getByPath(currentLimit, 'Amount');
    });
  }
  // If not blocked from removing limit or 'No limit' option is selected -> add 'No limit' option
  if (!validationState['limit-remove-blocked'] || value === 0 || value === '') {
    options.unshift({
      value: 0,
      label: messages.get('label.responsible-gaming.option.no-limit')
    });
  }
  // Add 'Other' option
  if (!hideOther) {
    options.push({
      value: 'other',
      label: valueType !== 'currency' ? messages.get('label.responsible-gaming.option.other-' + valueType) : messages.get('label.responsible-gaming.option.other')
    });
  }
  // Per transaction (0) limits are depricated, remove all other options but no limit.
  if (timespan === 0) {
    options = [getByPath(currentLimit, 'Amount'), getByPath(newLimit, 'Amount'), {
      value: 0,
      label: messages.get('label.responsible-gaming.option.no-limit')
    }].filter(function (v) {
      return v;
    }).sort();
  }

  var closeCustomAmount = function closeCustomAmount() {
    _onChange(currentLimit ? currentLimit.Amount : 0);
    setInputMode('select');
  };

  var _onChange = function _onChange(value) {
    if (value === 'other') {
      setInputMode('input');
      setValue('');
    } else {
      onChangeLimit(isNaN(parseInt(value)) ? getByPath(currentLimit, 'Amount') : parseInt(value));
    }
  };

  var isIphone = typeof window !== 'undefined' && navigator.platform === 'iPhone';

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-limit-selector' },
      inputMode === 'select' && React.createElement(
        Select,
        {
          options: options,
          value: value,
          onChange: function onChange(e, value) {
            return _onChange(value);
          } },
        options.map(function (o) {
          return React.createElement(
            Select.Option,
            { value: o.value },
            o.label
          );
        })
      ),
      inputMode === 'input' && React.createElement(
        Fragment,
        null,
        React.createElement(Input, {
          type: 'number',
          pattern: '\\d*',
          value: value,
          onChange: function onChange(e, value) {
            setValue(parseInt(value));
            if (value > 0) _onChange(value);
          },
          autoFocus: !isIphone,
          min: validationState['limit-remove-blocked'] ? '1' : '0',
          max: validationState['limit-increase-blocked'] ? getByPath(currentLimit, 'Amount') : Infinity
        }),
        React.createElement(
          Button,
          {
            type: 'button',
            onClick: closeCustomAmount,
            className: 'button mini tertiary' },
          React.createElement(Icon, { icon: 'times' })
        )
      )
    ),
    !hideRemainingLimit && typeof getByPath(currentLimit, 'RemainingAmount') === 'number' && React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      isTime ? messages.get('message.responsiblegaming.remaining-time') : messages.get('message.responsiblegaming.remaining-limit'),
      messages.getValue(currentLimit.RemainingAmount)
    ),
    showCurrentValue && typeof getByPath(currentLimit, 'Amount') === 'number' && React.createElement(
      'div',
      { className: 'ResponsibleGamingWidget__timespan-row' },
      messages.get('message.responsiblegaming.current-limit'),
      messages.getValue(currentLimit.Amount)
    )
  );
};